

























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DataTable from '@/app/ui/components/DataTable/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import TrashIcon from '@/app/ui/assets/trash_icon_alt.vue'
import EditIcon from '@/app/ui/assets/edit_icon.vue'
import ModalDelete from '../components/MarketplaceModal/ModalDelete.vue'
import ModalSuccess from '../components/MarketplaceModal/ModalSuccess.vue'
import controller from '@/app/ui/controllers/WhiteSellerController'
import { WhiteListSeller, WhiteSeller } from '@/domain/entities/WhiteSeller'
import { Utils } from '@/app/infrastructures/misc'
import { Location } from 'vue-router'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import MainController from '@/app/ui/controllers/MainController'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import PickupController from '@/app/ui/controllers/PickupController'

interface Params {
  page: number
  limit: number
  query: string
  status: string
}

@Component({
  components: {
    Button,
    TextInput,
    DropdownSelect,
    DataTable,
    PaginationNav,
    LoadingOverlay,
    TrashIcon,
    EditIcon,
    ModalDelete,
    ModalSuccess,
    WidgetDownload,
    EyeIcon,
    EyeDisabledIcon
  },
})
class ManageWhitelist extends Vue {
  controller = controller
  deleteModal = {
    show: false,
    ids: 0,
  }
  successDeleteModal = false
  filterOptions = [
    { label: 'Semua', value: 'all' },
    { label: 'Aktif', value: 'active' },
    { label: 'Tidak Aktif', value: 'inactive' },
  ]
  parameters = {
    page: 1,
    limit: 50,
    query: '',
    status: this.filterOptions[0],
  }

  // Table
  headers = [
    'No.',
    'Nama Seller',
    'No. Telephone',
    'Status',
    'Partner POS / Kurir',
    'Tipe Assign',
    'Seller Role',
  ]
  whiteListSeller = Array<string[]>([])
  loading = false;

  created(): void {
    this.fetchWhiteList()
  }

  get params(): Params {
    return {
      ...this.parameters,
      status: this.parameters.status.value,
      query: encodeURIComponent(this.parameters.query),
    }
  }

  get isLoadingExport(): boolean {
    return this.controller.loadingExport;
  }

  private indexTable(idx: number): string {
    const getCountData = (this.parameters.page - 1) * this.parameters.limit
    return String(getCountData + idx + 1)
  }

  private fetchWhiteList(reset?: boolean) {
    if (reset) this.parameters.page = 1
    controller.getAll(this.params)
  }

  private onSearchWhiteSeller = Utils.debounce(() => {
    this.fetchWhiteList(true)
  }, 400)

  private async onExport() {
    this.controller.getExportWhiteList()
  }

  private routeToAddSeller(): Location {
    return { name: 'AddSellerWhitelist' }
  }

  private routeTo(id: number, routeName: string): Location {
    return {
      name: routeName,
      params: { id: String(id) },
    }
  }

  private onDeleteModal(id: number) {
    this.deleteModal = {
      show: true,
      ids: id,
    }
  }

  private onDelete() {
    controller.deleteWhiteSeller({ ids: [this.deleteModal.ids] })
  }

  private onCloseModalSuccess() {
    this.successDeleteModal = false
    controller.setIsDeleteWhiteSellerSuccess(false)
  }

  @Watch('controller.dataWhiteListSeller')
  setDataWhiteListSeller(data: WhiteSeller[]): void {
    const result = data.map(list => {
      const partner = list.partnerPOS
        ? `${list.partnerPOS} [${list.partnerCode}] (POS)`
        : ''
      const courier = list.courierId
        ? `${list.courierId} - ${list.courierName} (Kurir)`
        : ''

      return [
        list.id,
        list.name,
        {phone: list.phone, id: list.id, role: list.role},
        list.status,
        partner || courier || '',
        list.assignType?.toUpperCase(),
        list.role,
      ]
    })
    this.whiteListSeller = <Array<string[]>>result
  }

  @Watch('controller.isDeleteWhiteSellerSuccess')
  setDeleteWhiteSellerSuccess(data: boolean): void {
    this.deleteModal.show = false
    if (data) {
      this.fetchWhiteList(true)
      this.successDeleteModal = data
    }
  }

  beforeDestroy(): void {
    controller.setIsDeleteWhiteSellerSuccess(false)
    MainController.setOpenWidgetDownload(false)
  }

  async showPhoneNumber(id = 0, role = "") {
    try {
      const resp = await PickupController.adminContactShow({
        resource: 'whitelist_seller',
        resourceId: String(id),
        field: 'whitelist_phone',
        source: 'whitelist-detail'
      });
      const phone = resp.value;
      const list = controller.dataWhiteListSeller.map((seller) => {
        if (seller.id === id) {
          seller.phone = phone;
          return seller
        }

        return seller
      });
      this.setDataWhiteListSeller(list);
    } finally {
      // no loading
    }
  }

  hidePhoneNumber(id = 0) {
    const list = controller.dataWhiteListSeller.map((seller) => {
      if (seller.id === id) {
        seller.phone = "";
        return seller
      }

      return seller
    });
    this.setDataWhiteListSeller(list);
  }
}
export default ManageWhitelist;
